import { selectCustomerIdentifier, setActiveLanguageMatcherId } from 'actions/identifier';
import { CLOSE_ICON_12 } from 'constants/commonIcons';
import { SEARCH_ICON } from 'constants/filterIcons';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getIdentifierCustomers, getSelectedCustomerIdentifier } from 'selectors/identifier';
import { useSelector } from 'store';

const CategorizerScopeSection: React.FC = () => {
  const dispatch = useDispatch();

  const selectedCustomer = useSelector(getSelectedCustomerIdentifier);
  const customers = useSelector(getIdentifierCustomers);

  const [isSearching, setIsSearching] = useState(false);
  const [search, setSearch] = useState('');

  const handleToggleSearch = (): void => {
    setIsSearching(!isSearching);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearch(e.target.value);
  };

  const handleSelectCustomer = (customer: string): void => {
    dispatch(selectCustomerIdentifier(customer));
    dispatch(setActiveLanguageMatcherId(''));
  };

  const filteredCustomers = customers.filter((c) =>
    c.name?.toLowerCase()?.includes(search.toLowerCase().trim())
  );

  return (
    <div className="flex flex-col">
      {isSearching ? (
        <div className=" flex flex-row px-4 py-2 w-full">
          <div className="flex flex-row w-full">
            <input
              id="search"
              name="search"
              className="border-l border-t border-b border-litlingo-gray-2 h-8 w-full text-litlingo-gray-6 pl-4 text-body placeholder-italic placeholder-litlingo-gray-6 rounded-l"
              placeholder="Search workspaces"
              onChange={handleSearchChange}
              value={search}
              autoComplete="off"
            />
            <button
              type="button"
              className="focus:outline-none border-t border-b border-r border-litlingo-gray-2 pr-2"
              onClick={(): void => {
                handleToggleSearch();
                setSearch('');
              }}
            >
              {CLOSE_ICON_12}
            </button>
          </div>
          <div className="flex items-center px-1 rounded-r border-t border-b border-r border-litlingo-gray-2 w-7 ">
            <button type="button" className="focus:outline-none w-5" onClick={handleToggleSearch}>
              {SEARCH_ICON()}
            </button>
          </div>
        </div>
      ) : (
        <div className="flex flex-row justify-between items-center px-4 py-2">
          <div className="text-litlingo-gray-6">{customers.length} Workspaces</div>

          <button
            type="button"
            className="w-7 h-8 p-1 border border-litlingo-gray-2 rounded focus:outline-none"
            onClick={handleToggleSearch}
          >
            {SEARCH_ICON()}
          </button>
        </div>
      )}
      <div className="flex flex-col">
        {filteredCustomers.map((c) => {
          const selected = c.uuid === selectedCustomer;

          return (
            <button
              type="button"
              key={c.uuid}
              className={`relative identifier-card-hover py-2.5 px-10 flex border-t border-litlingo-gray-2 focus:outline-none hover:z-10 ${
                selected ? 'bg-litlingo-success-light' : 'bg-white'
              }`}
              onClick={(): void => handleSelectCustomer(c.uuid)}
            >
              <p className={`${selected ? 'font-bold' : ''}`}>{c.name}</p>
              {selected && (
                <div className="absolute left-0 top-0 bottom-0 z-20">
                  <svg
                    width="5"
                    height="100%"
                    viewBox="0 0 5 64"
                    fill="none"
                    preserveAspectRatio="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="5" height="64" fill="#007656" />
                  </svg>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategorizerScopeSection;
